module.exports = __webpack_public_path__ + "static/media/default-video.77c48c95.svg";